<template>
<header>
    <!-- <img class="logo" :src="imgLogo" alt="logo"> -->
    <slot></slot>
    <div class="userInfo">
        <iv-dropdown
            v-if="account"
            placement="bottom-end"
            @on-click="onAccountDropdownClick">
            <div class="userInfo__button" :title="account.nickname">
                <iv-avatar :icon="account.nickname ? '' : 'md-person'">{{ account.nickname ? account.nickname.charAt(0).toUpperCase() : "" }}</iv-avatar>
                <iv-icon type="md-arrow-dropdown"></iv-icon>
            </div>
            <iv-dropdown-menu slot="list">
                <li class="dropdown-item">已登录用户 {{ account.username }}</li>
                <!-- <hr class="adm-hr" v-if="types.filter(type=>navigation_type!==type.id && templates[account.group].indexOf(type.id) > -1).length>0"> -->
                <!-- <template
                  v-for="type in types">
                  <iv-dropdown-item
                    v-if="navigation_type!==type.id && templates[account.group].indexOf(type.id) > -1"
                    :key="type.id"
                    :name="'navi:'+type.id">{{ type.name }}</iv-dropdown-item>
                </template> -->
                <iv-dropdown-item divided name="logout">登出</iv-dropdown-item>
            </iv-dropdown-menu>
        </iv-dropdown>
    </div>
</header>
</template>
<style lang="scss" scoped>
header{
    background: #ffffff;
    display: flex;
    justify-content: flex-end;
    height: 45px;
}
.ivu-menu-horizontal{
    height: 45px;
    line-height: 45px;
}
.userInfo{
    margin-right: 1.5rem;
    float: right;
    line-height: 45px;
    > *{
        line-height: initial;
    }
    &__button{
        > *{
            vertical-align: middle;
        }
    }
}
.dropdown-item{
    padding: 7px 16px;
    white-space: nowrap;
    list-style: none;
    font-weight: bold;
}
.logo{
    padding: 5px 15px;
    background: #fff;
    min-height: 45px;
    display: block;
    width: 150px;
    // width: 90%;
    // height: 30px;
    // background: #5b6270;
    // border-radius: 3px;
    // margin: 15px auto;
}
</style>
<script>
import imgLogo from "@/assets/images/headerLogo.png";
export default {
    data(){
        return {
            imgLogo,
        }
    },
    methods: {
        onAccountDropdownClick(name){
            if(name === 'logout') this.$$logout();
        }
    },
}
</script>

